/* Constants */
const REACT_APP_DTV_API_VERSION = 1;
const BASE_SUBSCRIBER_PATH = `/subscriber/v${REACT_APP_DTV_API_VERSION}/`;

export const SUBSCRIBER = {
  federatedLogin: `${BASE_SUBSCRIBER_PATH}Users/Login/Federated`,
  login: `${BASE_SUBSCRIBER_PATH}users/loginDevice`,
  renewToken: `${BASE_SUBSCRIBER_PATH}Users/RenewToken`
};
